import { useState, useEffect } from 'react';

export const useLocale = () => {
  const [locale, setLocale] = useState('EN');

  useEffect(() => {
    const htmlLang = document.documentElement.lang;
    const langCode = htmlLang
      .substring(0, 2)
      .split('')
      .map((char) => char.toUpperCase())
      .join('');

    setLocale(langCode || 'EN');
  }, []);

  return { locale, setLocale };
};
